module.exports = __webpack_public_path__ + "img/7.5d09dc2b.jpg";